import React, {memo} from 'react';
import PropTypes from 'prop-types';
import Breadcrump from 'cms/helpers/Breadcrump';
import LazyImage from 'helpers/LazyImage';
import useImageSize from 'helpers/hooks/useImageSize';
import {replaceAssetsImgUrl, calcBackgroundFullWidth} from 'cms/helpers/common';

const TopHero = ({
  title, subTitle, bgImage, sectionHeight, logo, breadcrump, containerClass, childrenClass, children
}) => {
  const [width, height] = useImageSize(replaceAssetsImgUrl(logo));

  return (
    <section className="position-relative" style={{height: sectionHeight}}>
      <img
        className="position-absolute w-1-1 h-1-1 img-cover"
        src={replaceAssetsImgUrl(bgImage, calcBackgroundFullWidth())}
      />
      <div className="position-relative bg-overlay-mid pt-1 h-1-1">
        <div className={`container ${containerClass}`}>
          <Breadcrump breadcrump={breadcrump} />
          <div className={childrenClass}>
            {
              (title || logo) &&
              <div className="text-light text-center">
                {
                  title && <h1 className="display-2 mb-4">
                    <span dangerouslySetInnerHTML={{__html: title}} />
                    {subTitle &&
                      <span
                        className="text-normal font-normal"
                        dangerouslySetInnerHTML={{__html: subTitle}}
                      />
                    }
                  </h1>
                }
                {logo && width &&
                  <LazyImage
                    wrapperClass="pb-4 d-flex justify-content-center"
                    src={replaceAssetsImgUrl(logo, 250)}
                    width={width > height ? 250 : 150}
                    height="auto"
                    title={title}
                    alt={title}
                  />
                }
              </div>
            }
            {Boolean(children) && children}
          </div>
        </div>
      </div>
    </section>
  );
};

TopHero.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  bgImage: PropTypes.string.isRequired,
  sectionHeight: PropTypes.string.isRequired,
  logo: PropTypes.string,
  breadcrump: PropTypes.array,
  containerClass: PropTypes.string,
  childrenClass: PropTypes.string,
  children: PropTypes.node
};

TopHero.defaultProps = {
  sectionHeight: '480px',
  logo: '',
  containerClass: ''
};

export default memo(TopHero);
